import React, {useEffect, useMemo, useState} from 'react';
import {Helmet} from 'react-helmet';
import {NavLink} from 'react-router-dom';
import {CSSTransition} from 'react-transition-group';
import {compose} from 'redux';
import './styles.css';
import JobDetails from '../../components/JobDetails';
import PanelContainer from '../../components/PanelContainer';
import ShareButton from '../../components/ShareButton';
import {ANIMATION_TIMEOUT_APPEAR} from '../../constants/animation';
import ENDPOINT from '../../constants/endpoints';
import ROUTE from '../../constants/route';
import LinkBuilder from '../../helpers/link-builder';
import {linkedInShareUrl} from '../../helpers/share';
import withProcessActions from '../../hocs/withProcessActions';
import useApi from '../../hooks/useApi';
import PageLayout from '../../layouts/PageLayout';
import Sidebar from '../../scenes/Sidebar';

const JobProfile = props => {
  const {
    match: {
      params: { id },
    },
    history,
    location: { pathname, search },
    processAction: { jobPush, jobClose, jobReopen, jobRefresh },
  } = props;

  const api = useApi();
  const [process, setProcess] = useState();

  const backPathname = useMemo(() => {
    return pathname.replace(`/${id}`, '');
  }, []);

  const openLinkedInSharingWindow = () =>
    linkedInShareUrl(
      window.location.origin + LinkBuilder.getProcessPublicLink(process.Id, 'process')
    );

  useEffect(() => {
    api.get(
      ENDPOINT.ENTITY.JOB,
      { id },
      {
        handleError: () => history.replace(ROUTE.ERROR_404),
        handleSuccess: process => {
          setProcess(process);

          if (search) {
            const params = new URLSearchParams(search);
            const action = params.get('action');

            if (action) {
              history.replace(pathname);
            }

            if ('reopen' === action) {
              jobReopen(process.ProcessID);
            }

            if ('refresh' === action) {
              jobRefresh(process.ProcessID);
            }

            if ('push' === action) {
              jobPush(process.ProcessID);
            }

            if ('close' === action) {
              jobClose(process.ProcessID);
            }
          }
        },
      }
    );
  }, [history.location]);

  return (
    <PageLayout
      pageClass="job-profile"
      mainContent={
        <>
          {process && (
            <CSSTransition
              in={true}
              appear={true}
              timeout={ANIMATION_TIMEOUT_APPEAR}
              classNames="fade"
            >
              <PanelContainer>
                <Helmet>
                  <title>{process.PositionTitle}</title>
                </Helmet>
                <JobDetails
                  job={process}
                  mode="recruiter"
                  showDeadlineSendInBound={false}
                  showBaseStartDate={true}
                />
                <div className="job-profile__controls">
                  <NavLink to={backPathname} className="job-profile__back-btn">
                    Back
                  </NavLink>
                  {process.BlockLinkedInSharing === 'No' &&
                    process.Approved === 'Yes' && (
                      <ShareButton
                        caption="Share on Linkedin"
                        separatorLeft={true}
                        action={openLinkedInSharingWindow}
                      />
                    )}
                </div>
              </PanelContainer>
            </CSSTransition>
          )}
        </>
      }
      sidebarContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <Sidebar />
        </CSSTransition>
      }
    />
  );
};

export default compose(withProcessActions)(JobProfile);
